/* Waitlist client app */
angular.module('widgetSitePicker', ['config', 'ngRoute'])

angular.module('widgetSitePicker').config([
	'$routeProvider',
	'$locationProvider',
	function ($routeProvider, $locationProvider) {
		$routeProvider
			.when('/widgetSitePicker/notFound', {
				templateUrl: '/app/widgetSitePicker/templates/notFound',
			})
			.when('/widgetSitePicker/:venueId', {
				templateUrl: '/app/widgetSitePicker/templates/sitePicker',
			})
			.otherwise({
				templateUrl: '/app/widgetSitePicker/templates/notFound',
			})

		$locationProvider.html5Mode(true)
	},
])

angular.module('widgetSitePicker').factory('dataFactory', [
	'$http',
	'$location',
	'tgConfig',
	function ($http, $location, tgConfig) {
		$http.defaults.headers.common.apptoken = tgConfig.apptoken
		var urlBase = tgConfig.api.replace('http', $location.protocol()) + '/'
		var dataFactory = {}

		dataFactory.getVenuesByParent = function (parentId) {
			var httpConfig = {
				method: 'GET',
				url: urlBase + 'Venue/' + parentId + '/byParent',
				params: { select: '_id name.pt' }
			}

			return $http(httpConfig)
		}

		return dataFactory
	},
])
